import { render, staticRenderFns } from "./EditPrivilege.vue?vue&type=template&id=0a047a4a&scoped=true"
import script from "./EditPrivilege.vue?vue&type=script&lang=js"
export * from "./EditPrivilege.vue?vue&type=script&lang=js"
import style0 from "./EditPrivilege.vue?vue&type=style&index=0&id=0a047a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a047a4a",
  null
  
)

export default component.exports